/**
 * @file Alert组件
 * @author (zhangwenting)
 */
import Alert from './Alert.js';
export default Alert;